module.exports = __webpack_public_path__ + "static/media/info02admindineroerrorescomunes.59b390a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/info02admindineroerrorescomunes.mp4
// module id = 818
// module chunks = 1